export const removeUndefined = <T>(obj: T) : Partial<T> => {
    return Object.keys(obj).reduce((res, key) => {
        if(obj[key] !== undefined)
            res[key] = obj[key];
        return res;
    }, {});
}


// WEBPACK FOOTER //
// ./src/utils/removeUndefined.ts